import './EntityLimitsTable.scss';
import { SonarTable } from '@ui/SonarTable';
import { useApiResource } from '@hooks';
import { getColumns } from './EntityLimitsTableColumns';
import React, { useMemo } from 'react';
const getRowKey = (limit) => limit.id;
const sortDirections = ['ascend', 'descend', 'ascend'];
export const EntityLimitsTable = ({ sonarObjectId }) => {
    const { loading, resource } = useApiResource(`v2/salesforce/SfEntityDefinitions/${sonarObjectId}/limits`);
    const columns = useMemo(getColumns, []);
    return (React.createElement(SonarTable, { className: 'entity-limits-table', columns: columns, dataSource: resource, loading: loading, pagination: false, rowKey: getRowKey, sortDirections: sortDirections, sticky: true }));
};
